import { render, staticRenderFns } from "./map-select-asset.vue?vue&type=template&id=7065ef46&scoped=true&"
import script from "./map-select-asset.vue?vue&type=script&lang=js&"
export * from "./map-select-asset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7065ef46",
  null
  
)

export default component.exports